"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _browserHelpers = require("@flowio/browser-helpers");

var _riskified = _interopRequireDefault(require("./riskified"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var init = function init(options) {
  // here is where we can make a determiniation
  // about which provider to use when we have more
  // than one.
  (0, _browserHelpers.domContentLoaded)(function () {
    _riskified["default"].init(options);
  });
};

var _default = {
  init: init
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/lib/index.js
// module id = 549
// module chunks = 0 1